import * as R from 'ramda';
import { ERROR_CODES, ERROR_MESSAGES } from 'src/constants/error';
export var parseErrorMessage = function parseErrorMessage(error, t) {
  console.log(error === null || error === void 0 ? void 0 : error.code, error === null || error === void 0 ? void 0 : error.message, ERROR_MESSAGES[error === null || error === void 0 ? void 0 : error.code]);

  if (error !== null && error !== void 0 && error.code && R.has(error.code, ERROR_MESSAGES)) {
    return formatErrorMessage(error.code, t(ERROR_MESSAGES[error.code].i18n));
  } else {
    var _error$code, _error$message;

    return formatErrorMessage((_error$code = error === null || error === void 0 ? void 0 : error.code) !== null && _error$code !== void 0 ? _error$code : ERROR_CODES.UNEXPECTED, (_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : t(ERROR_MESSAGES[ERROR_CODES.UNEXPECTED].i18n));
  }
};
export var formatErrorMessage = function formatErrorMessage(error_code, error_message) {
  return "[".concat(error_code, "] ").concat(error_message);
};